<template>
	<div>
		<div v-if="view==='search'" class="text-left">
			<!-- <h1 class="text-center">Users Component</h1> -->

			<div class="UsersHome">
				<h1 class="left-align">Search User</h1>
				<v-row no-gutters>
					<v-col>
						<p class="p3 left-align">Enter email</p>
					</v-col>
					<v-col></v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<v-text-field
							outlined
              label="username@email.com "
              single-line
              hide-details
              v-model="filterUserNameValue"
							@keyup.enter="searchUser()"
							ref="firstFocus"
            ></v-text-field>
					</v-col>
					<v-col>
						<v-btn @click="searchUser()"  class="btn-default" text>Search</v-btn>
						<v-btn @click="clearFilters()" class="btn-default" text>Clear</v-btn>
					</v-col>
				</v-row>
				<br>
				<div v-show="headers.length !== 0" class="track-respondents-table-container">
					<v-data-table
						:headers="headers"
						:items="respondents"
						item-key="userName"
						class="elevation-1"
						:page.sync="page"
						:items-per-page="itemsPerPage"
						hide-default-footer
						@page-count="pageCount = $event"
					>
						<template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
							<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
						</template>
						<!-- <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
							<v-tooltip  :disabled="h.hover === ''" :key="h.value" bottom color="#333">
								<template v-slot:activator="{ on }">
									<span v-on="on">{{h.text}}</span>
								</template>
								<span>{{h.hover}}</span>
							</v-tooltip>
						</template> -->
						<template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-account-details
              </v-icon>
            </template>
					</v-data-table>
					<div class="pagination-container">
						<v-row>
							<v-col :cols="2">
								<v-text-field
									:value="itemsPerPage"
									label="Items per page"
									type="number"
									min="1"
									max="15"
									@input="itemsPerPage = parseInt($event, 10)"
								></v-text-field>
							</v-col>
							<v-col :cols="10">
								<v-pagination
									v-model="page"
									:length="pageCount"
								></v-pagination>
							</v-col>
						</v-row>
					</div>
				</div>
			</div>
		</div>

		<div v-else>
			<userdetails v-on:backToSearch="view='search'" :userInfo="userInfo"></userdetails>
		</div>

	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';
import { Roles } from '@/common/Roles.js';
export default {
	name: 'UsersPage',
	props: {
		userToDisplay: String
	},
	data: () => ({
		selected: [],
		respondents: [],
		page: 1,
		pageCount: 0,
		itemsPerPage: 10,
		filterUserNameValue: '',
		view: '',
		userInfo: {}
	}),
	mounted () {
		this.view = 'search';

		if (this.userToDisplay && this.userToDisplay !== '') {
			this.filterUserNameValue = this.userToDisplay;
			this.searchUser()
				.then(() => {
					this.userInfo = this.respondents[0];
					this.view = 'd';
				});
		}
	},
	computed: {
		headers: function () {
			return [
				{ text: 'UserName', value: 'userName', hover: '', class: 'data-table-header' },
				{ text: 'FirstName', value: 'firstName', hover: '', class: 'data-table-header' },
				{ text: 'LastName', value: 'lastName', hover: '', class: 'data-table-header' },
				{ text: 'User Details', value: 'actions', hover: '', class: 'data-table-header', sortable: false }
			]
		}
	},
	methods: {
		filterUsername (val) {
			if (!this.filterUserNameValue) {
				return true;
			}

			return val.toLowerCase().includes(this.filterUserNameValue.toLowerCase());
		},
		clearFilters () {
			this.filterUserNameValue = '';
			this.respondents = [];
		},
		selectAll () {
			this.selected = this.respondents;
		},
		deselectAll () {
			this.selected = [];
		},
		async searchUser () {
			var rawRespondents;
			await	researcherApiService.searchUser(this.filterUserNameValue, Roles.Researcher)
				.then(function (response) {
					if (response && response.data) {
						rawRespondents = response.data;
					}
				});
			this.respondents = rawRespondents;
		},
		editItem (it) {
			console.log(it);
			this.userInfo = it;
			this.view = 'd';
		}
	}
}
</script>

<style>

</style>
